var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 18.2222C22 18.6937 21.8084 19.1459 21.4675 19.4793C21.1265 19.8127 20.664 20 20.1818 20H3.81818C3.33597 20 2.87351 19.8127 2.53253 19.4793C2.19156 19.1459 2 18.6937 2 18.2222V8.44444C2 7.97295 2.19156 7.52076 2.53253 7.18737C2.87351 6.85397 3.33597 6.66667 3.81818 6.66667H7.45455L9.27273 4H14.7273L16.5455 6.66667H20.1818C20.664 6.66667 21.1265 6.85397 21.4675 7.18737C21.8084 7.52076 22 7.97295 22 8.44444V18.2222Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.2a0fad3ab0961d8ca4ba94c080c1883c.svg";
export { ForwardRef as ReactComponent };